export class ChatAction {
  public action: string;
  public step: string;
  public value: string;
  public message: string;
  public meta: any;

  constructor(action: string, step: string, value?: string, message?: string, meta?: any) {
    this.action = action;
    this.step = step;
    this.value = (value === undefined || value === null) ? '' : value;   // 0 is a real answer ($0 balance, 0% down) — never coerce it away
    this.message = message || '';
    this.meta = meta || {};
  }
}
